export const slugify = (s: string): string => s.toLowerCase().replace(/ /g, "-");

export const convertToTitleCase = (wordToConvert: string) => {
  const result = wordToConvert.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};
